import { defineComponent as _defineComponent } from 'vue'
import CiButton from "@components/base/button.vue";
import CiProductTile from "@components/products/tile.vue";
import { useInternalTracking } from "@composables/internalTracking";


export default /*#__PURE__*/_defineComponent({
  __name: 'partner-products',
  props: {
    products: null,
    loading: { type: Boolean, default: true }
  },
  emits: ["tracking-click"],
  setup(__props: any, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { products: Products.TileData[], loading: boolean };



const { propagateTrackClick } = useInternalTracking(emit, "ProductsLibrary");

return { __sfc: true,props, emit, propagateTrackClick, CiButton, CiProductTile }
}

})